import { render, staticRenderFns } from "./NotificationInfoTab.vue?vue&type=template&id=4c03e73f&"
import script from "./NotificationInfoTab.vue?vue&type=script&lang=js&"
export * from "./NotificationInfoTab.vue?vue&type=script&lang=js&"
import style0 from "./NotificationInfoTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports